<template>
  <div class="mt-2">
    <b-overlay :show="loading" rounded="sm" no-fade>
      <b-card>
        <b-row>
          <b-col xl="12" md="12" sm="12" cols="12">
            <b-row>
              <b-col xl="3" md="12" sm="12">
                <b-form-group>
                  <v-select
                    id="event"
                    v-model="selectedEvent"
                    :options="eventTypes"
                    :reduce="(val) => val"
                    :filterable="true"
                    @option:selected="selectedEvents"
                    label="title"
                    :clearable="false"
                    input-id="event"
                  />
                </b-form-group>
              </b-col>

              <b-col xl="2" md="12" sm="12">
                <b-form-group>
                  <v-select
                    id="observer"
                    v-model="selectedObserver"
                    :options="observerOptions"
                    :reduce="(val) => val"
                    :filterable="true"
                    @option:selected="filterObserver"
                    label="title"
                    :clearable="false"
                    input-id="observer"
                  />
                </b-form-group>
              </b-col>

              <b-col xl="2" md="12" sm="12">
                <b-form-group>
                  <v-select
                    id="event"
                    v-model="selectedStatus"
                    :options="statusTypes"
                    :reduce="(val) => val"
                    :filterable="true"
                    @option:selected="filterStatus"
                    label="title"
                    :clearable="false"
                    input-id="event"
                  />
                </b-form-group>
              </b-col>

              <b-col xl="2" md="12" sm="12">
                <b-form-group class="mb-40">
                  <b-input-group>
                    <b-form-input
                      id="filter-input"
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                    ></b-form-input>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col xl="3" md="12" sm="12">
                <b-form-group>
                  <b-input-group>
                    <flat-pickr
                      placeholder="Date Range"
                      v-model="rangeDate"
                      class="form-control"
                      :config="{ mode: 'range', dateFormat: 'd/m/Y' }"
                    />
                    <b-input-group-append>
                      <b-button @click="clearDate()" variant="warning"
                        >Clear</b-button
                      >
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>

              <b-col xl="2" md="12" sm="12">
                <b-form-group>
                  <b-button
                    @click="sendProject()"
                    block
                    class="float-right"
                    v-if="this.$Can('add_review') || userData.quality_reviewer"
                    variant="warning"
                  >
                    New Review
                  </b-button>
                </b-form-group>
              </b-col>
            </b-row>

            <b-table
              striped
              hover
              ref="refUserListTable"
              class="position-relative"
              :items="listReviewsData"
              selectable
              select-mode="single"
              responsive
              :small="false"
              :fields="inHeaders"
              show-empty
              empty-text="No matching records found"
              @row-selected="onRowSelected"
              :per-page="0"
            >
              <!-- Column: Id -->
              <template #cell(id)="data">
                <!--   <b-link :to="{ name: 'customer-edit', params: { id: data.item.id } }" class="font-weight-bold"> #{{ data.value }} </b-link>-->
                <strong class="text-primary">#{{ data.item.id }}</strong>
              </template>

              <template #cell(firstName)="data">
                <span class="font-weight-bold">
                  {{ data.item.firstName ? data.item.firstName : "N/A" }}
                </span>
              </template>
              <template #cell(lastName)="data">
                <span class="font-weight-bold">
                  {{ data.item.lastName ? data.item.lastName : "N/A" }}
                </span>
              </template>
              <template #cell(observer)="data">
                <span class="font-weight-bold">
                  {{ data.item.observer ? data.item.observer : "N/A" }}
                </span>
              </template>
              <template #cell(questionnaire)="data">
                <span class="font-weight-bold">
                  {{ data.item.event ? data.item.event.title : "N/A" }}
                </span>
              </template>
              <template #cell(status)="data">
                <span class="font-weight-bold">
                  <strong
                    :class="
                      data.item.status === 'C' ? 'text-success' : 'text-warning'
                    "
                  >
                    <feather-icon
                      size="18"
                      v-b-tooltip.hover
                      :title="
                        data.item.status === 'C'
                          ? 'This quality review has been completed'
                          : 'This quality review is still in progress'
                      "
                      :icon="
                        data.item.status === 'C'
                          ? 'CheckIcon'
                          : 'AlertTriangleIcon'
                      "
                      :class="
                        data.item.status !== 'C'
                          ? 'animate__animated animate__heartBeat'
                          : ''
                      "
                    />
                  </strong>
                </span>
              </template>
              <template #cell(surveyDate)="data">
                <span class="font-weight-bold">
                  {{
                    data.item.surveyDate
                      ? dateFormat(data.item.surveyDate)
                      : "N/A"
                  }}
                </span>
              </template>

              <!-- Column: Review Type -->
              <template #cell(reviewType)="data">
                <b-badge
                  v-if="data.item.review_type === 'followup'"
                  :variant="data.item.interval_months === 6 ? 'info' : 'primary'"
                >
                  {{ data.item.interval_months }}-Month
                </b-badge>
                <b-badge v-else variant="secondary">Initial</b-badge>
              </template>

              <!-- Column: Actions -->
              <template #cell(actions)="data">
                <b-dropdown
                  v-if="
                    $Can('edit_review') ||
                      $Can('delete_review') ||
                      $Can('archive_review') ||
                      userData.quality_reviewer
                  "
                  variant="link"
                  no-caret
                  :right="true"
                  boundary="viewport"
                  class="actions-dropdown"
                >
                  <template #button-content>
                    <feather-icon
                      icon="MoreVerticalIcon"
                      size="16"
                      class="align-middle text-body"
                    />
                  </template>
                  <b-dropdown-item
                    :to="{
                      name: 'review-edit',
                      params: { id: data.item.id },
                    }"
                    v-if="$Can('edit_review') || userData.quality_reviewer"
                  >
                    <feather-icon icon="FileTextIcon" />
                    <span class="align-middle ml-50">Details </span>
                  </b-dropdown-item>

                  <b-dropdown-item
                    v-if="$Can('delete_review')"
                    @click="deleteReview(data.item.id)"
                  >
                    <feather-icon icon="DeleteIcon" />
                    <span class="align-middle ml-50">Delete Review</span>
                  </b-dropdown-item>

                  <b-dropdown-item
                    v-if="$Can('archive_review') || userData.quality_reviewer"
                    @click="updateArchive(data.item.id, data.item.archive)"
                  >
                    <feather-icon icon="SendIcon" />
                    <span class="align-middle ml-50">{{
                      data.item.archive == "N"
                        ? "Send to archive"
                        : "Retrieve from archive"
                    }}</span>
                  </b-dropdown-item>
                </b-dropdown>
              </template>
            </b-table>

            <div class="mx-2 mb-2">
              <b-row>
                <b-col
                  cols="12"
                  sm="6"
                  class="d-flex align-items-center justify-content-center justify-content-sm-start"
                >
                  <span class="text-muted"
                    >Showing {{ dataMeta.from }} to {{ dataMeta.to }} of
                    {{ dataMeta.of }} entries</span
                  >
                  <b-form-select
                    v-model="perPage"
                    :options="pageOptions"
                    size="sm"
                    class="ml-1"
                    style="width: auto"
                    @change="onPerPageChange"
                  />
                </b-col>

                <!-- Pagination -->
                <b-col
                  cols="12"
                  sm="6"
                  class="d-flex align-items-center justify-content-center justify-content-sm-end"
                >
                  <b-button
                    v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                    variant="outline-warning"
                    class="mr-1"
                    @click="showArchiveRecords()"
                  >
                    {{
                      archive == "N"
                        ? "Show with archive records"
                        : "Hide with archive records"
                    }}
                  </b-button>
                  <b-pagination
                    v-model="currentPage"
                    :total-rows="totalRows"
                    :per-page="perPage"
                    first-number
                    last-number
                    class="mb-0 mt-1 mt-sm-0"
                    prev-class="prev-item"
                    next-class="next-item"
                    @change="onPageChange"
                  >
                    <template #prev-text>
                      <feather-icon icon="ChevronLeftIcon" size="18" />
                    </template>
                    <template #next-text>
                      <feather-icon icon="ChevronRightIcon" size="18" />
                    </template>
                  </b-pagination>
                </b-col>
              </b-row>
            </div>
          </b-col>
        </b-row>
      </b-card>
    </b-overlay>
  </div>
</template>

<script>
// import { BFormFile } from "bootstrap-vue";
import {
  BImg,
  BOverlay,
  BCard,
  BFormGroup,
  BRow,
  BCol,
  BFormInput,
  BFormSelect,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
} from "bootstrap-vue";
import axiosIns from "@/libs/axios";
import store from "@/store";
import router from "@/router";
import { onUnmounted } from "@vue/composition-api";
import reviewStoreModule from "./reviewStoreModule";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import moment from "moment";
import _ from "lodash";
import vSelect from "vue-select";
import Ripple from "vue-ripple-directive";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import "animate.css";
export default {
  components: {
    BImg,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BFormSelect,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BOverlay,
    BFormGroup,
    moment,
    vSelect,
    flatPickr,
    ValidationProvider,
    ValidationObserver,
  },
  created() {
    // Debounced search so typing in the filter box doesn't fire a request per keystroke.
    this.debouncedSearch = _.debounce(this.getReviewResults, 500);
  },
  mounted() {
    // this.getItems();
    this.getObserverOptions();
    this.getReviewResults();

    // Add event listener for dropdown positioning
    this.$nextTick(() => {
      this.setupDropdownPositioning();
    });
  },
  setup() {
    const SETTINGS_APP_STORE_MODULE_NAME = "review";
    // Register module
    if (!store.hasModule(SETTINGS_APP_STORE_MODULE_NAME))
      store.registerModule(SETTINGS_APP_STORE_MODULE_NAME, reviewStoreModule);
    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(SETTINGS_APP_STORE_MODULE_NAME))
        store.unregisterModule(SETTINGS_APP_STORE_MODULE_NAME);
    });
    return { selected: ["Admin", "User"] };
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("userData")),
      rangeDate: null,
      filterDateStart: null,
      filterDateEnd: null,
      file: null,
      excelJson: {},
      edit: null,
      newitem: "",
      archive: "N",
      filter: null,
      filterEvent: null,
      filterQuery: null,
      filterOn: ["firstName", "lastName", "observer"],
      perPage: 30,
      loading: false,
      selectedEvent: { id: 0, title: "All Questionnaire", value: null },
      selectedStatus: { id: 0, title: "All Status", value: null },
      selectedObserver: { id: 0, title: "All Observers", value: null },
      items: [],
      ans: null,
      where: router.currentRoute.name,
      currentPage: 1,
      pageOptions: [20, 30, 40, 50],
      totalRows: 0,
      listReviewsData: [],
      selectedData: [],
      prevItem: null,
      answerTypes: [1, 2, 3, 4, "Not Observed"],
      eventTypes: [{ id: 0, title: "All Questionnaire", value: null }],
      observerOptions: [{ id: 0, title: "All Observers", value: null }],
      statusTypes: [
        { id: 0, title: "All Status", value: null },
        { id: 1, title: "Completed", value: "C" },
        { id: 2, title: "In Progress", value: "A" },
      ],
      inHeaders: [
        { key: "id", sortable: true, class: "text-center" },
        {
          key: "firstName",
          label: "FIRST NAME",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          key: "lastName",
          label: "LAST NAME",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          key: "observer",
          label: "REVIEWER",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          key: "questionnaire",
          label: "QUESTIONNAIRE",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          key: "surveyDate",
          label: "DATE",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          key: "reviewType",
          label: "TYPE",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          key: "status",
          label: "status",
          thClass: "text-center status",
          tdClass: "text-center status",
        },
        {
          key: "actions",
          label: "ACTIONS",
          thClass: "text-center",
          tdClass: "text-center",
        },
      ],
      colWidthFactor: null,
      tempStatusOptions: [{ label: "Draft", value: "A" }],
    };
  },
  computed: {
    dataMeta() {
      return {
        from:
          this.totalRows != 0 ? this.perPage * (this.currentPage - 1) + 1 : 0,
        to:
          this.perPage * (this.currentPage - 1) + Number(this.perPage) <
          this.totalRows
            ? this.perPage * (this.currentPage - 1) + Number(this.perPage)
            : this.totalRows,
        of: this.totalRows,
      };
    },
  },
  methods: {
    buildListResultPayload(extra = {}) {
      return {
        event: this.selectedEvent ? this.selectedEvent : null,
        status: this.selectedStatus ? this.selectedStatus.value : null,
        observer_id:
          this.selectedObserver && this.selectedObserver.id
            ? this.selectedObserver.id
            : null,
        filterDate: {
          startDate: this.filterDateStart,
          endDate: this.filterDateEnd,
        },
        archive: this.archive,
        // Server-side pagination + search
        page: this.currentPage,
        perPage: this.perPage,
        search: this.filter || null,
        ...extra,
      };
    },
    takeAQuestionAnswer(ans) {
      this.ans = ans;
    },
    getObserverOptions() {
      axiosIns
        .get("ReviewOptions")
        .then((res) => {
          const rows = Array.isArray(res.data) ? res.data : [];
          const options = rows.map((u) => {
            const title = [u.name, u.surname].filter(Boolean).join(" ").trim();
            return {
              id: u.id,
              title: title || u.email || `User #${u.id}`,
              value: u.id,
            };
          });
          this.observerOptions = [
            { id: 0, title: "All Observers", value: null },
            ...options,
          ];
        })
        .catch((error) => {
          console.log(error);
          this.observerOptions = [{ id: 0, title: "All Observers", value: null }];
        });
    },
    dateFormat(val) {
      if (val != undefined) {
        // Try to parse the date - backend might send in MM-DD-YYYY format
        const date = moment(
          String(val),
          ["MM-DD-YYYY", "M-D-YYYY", "YYYY-MM-DD"],
          true
        );
        if (date.isValid()) {
          return date.format("DD/MM/YYYY");
        }
        // Fallback to default parsing if specific format fails
        return moment(String(val)).format("DD/MM/YYYY");
      }
    },
    selectedGroupValue(val) {
      //   let findedGroup = this.allGroupsData.find((e) => e.id == val.groupId);
      // this.reviewData.questionAnswer.forEach((question) => {
      //   if(question.questionId == Number(val.id)) {
      //       question.commentAnswer = this.ans
      //   }
      // })
    },
    downloadPdf() {
      this.download = true;
      this.loading = true;
      // store.dispatch('accounting/profitLossPdf', { start: this.filterDateStart, end: this.filterDateEnd }).then((response) => {
      let selected = this.eventTypes.filter(
        (x) => x.name.slice(0, 3) == this.filterEvent
      )[0].id;
      store
        .dispatch("review/createReviewPdf", { eventId: selected })
        .then((response) => {
          if (response.status == 200) {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "Profit Loss Statement.pdf");
            document.body.appendChild(link);
            link.click();
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Successful",
                text: "✔️ Report is created!",
                icon: "ThumbsUpIcon",
                variant: "success",
              },
            });
            this.download = false;
            this.loading = false;
          }
        });
    },
    sendProject(val) {
      router.push({ name: "review-add" });
    },
    showQuotes(item) {
      if (this.prevItem !== null) {
        this.prevItem._showDetails = false;
        this.prevItem = item;
      } else {
        this.prevItem = item;
      }
      this.selectedData = item;
      item.dropList = "quotes";
      item._showDetails = !item._showDetails;
    },
    onRowSelected(item) {
      if (this.$Can("edit_review") || this.userData.quality_reviewer) {
        router.push({ name: "review-edit", params: { id: item[0].id } });
      }
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    clearDate() {
      if (this.rangeDate != null && this.rangeDate != "") {
        this.filterDateStart = null;
        this.filterDateEnd = null;
        this.rangeDate = null;
        this.getReviewResults();
      }
    },
    getReviewResults() {
      this.loading = true;

      let filter = this.buildListResultPayload();
      store
        .dispatch("review/getAllReviewResults", filter)
        .then((res) => {
          this.applyReviewResponse(res);
        })
        .catch((error) => {
          this.loading = false;
          console.log(error);
        });
    },
    // Normalises the listResult response. The list endpoint returns a paginated
    // envelope ({ data, total, events }); other callers still get a plain array, so
    // we handle both shapes here.
    applyReviewResponse(res) {
      const payload = res.data || {};
      const isPaginated = !Array.isArray(payload);

      const rows = isPaginated ? payload.data || [] : payload;
      const events = isPaginated
        ? payload.events || []
        : rows.map((element) => element.event);

      this.listReviewsData = rows;
      this.totalRows = isPaginated ? payload.total || 0 : rows.length;

      events.forEach((event) => {
        if (event) this.eventTypes.push(event);
      });
      this.eventTypes = _.uniqBy(this.eventTypes, function(e) {
        return e.id;
      });

      this.loading = false;
      // Re-setup dropdown positioning after data load
      this.$nextTick(() => {
        this.setupDropdownPositioning();
      });
    },
    onPageChange(page) {
      this.currentPage = page;
      this.getReviewResults();
    },
    onPerPageChange() {
      this.currentPage = 1;
      this.getReviewResults();
    },
    deleteReview(id) {
      const self = this;
      this.$swal({
        title: "Are you sure you want to delete the review?",
        // text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.isConfirmed) {
          store
            .dispatch("review/deleteReview", id)
            .then((res) => {
              self.getReviewResults();
              self.$swal.fire(
                "Deleted!",
                "Quality Review has been deleted.",
                "success"
              );
            })
            .catch((error) => {
              console.log(error);
            });
        }
      });
    },

    updateArchive(id, status) {
      const self = this;
      if (status == "N") {
        this.$swal({
          title:
            "Are you sure you want to send the quality review to the archive?",
          text: "Quality Review won't participate in calculations and graphs",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#fcb416",
          cancelButtonColor: "#ea5455 ",
          confirmButtonText: "Yes, send to archive it!",
          customClass: {
            confirmButton: "btn btn-warning mr-1",
            cancelButton: "btn btn-danger",
            denyButton: "btn btn-primary",
          },
        }).then((result) => {
          if (result.isConfirmed) {
            store
              .dispatch("review/updateArchive", { id: id, status: "Y" })
              .then((res) => {
                self.getReviewResults();
                self.$swal.fire(
                  "Archived!",
                  "Quality Review has been sended archive",
                  "success"
                );
              })
              .catch((error) => {
                console.log(error);
              });
          }
        });
      } else {
        this.$swal({
          title: "Do you want to retrieve the quality review from the archive?",
          text: "Quality Review will be added to calculations and graphs.",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, retrieve from archive it!",
          customClass: {
            confirmButton: "btn btn-success mr-1",
            cancelButton: "btn btn-danger",
            denyButton: "btn btn-primary",
          },
        }).then((result) => {
          if (result.isConfirmed) {
            store
              .dispatch("review/updateArchive", { id: id, status: "N" })
              .then((res) => {
                self.getReviewResults();
                self.$swal.fire(
                  "Retrieved from archive!",
                  "Quality Review has been retrieved from archive.",
                  "success"
                );
              })
              .catch((error) => {
                console.log(error);
              });
          }
        });
      }
    },
    showArchiveRecords() {
      this.currentPage = 1; // Reset to first page when archive toggle changes
      if (this.archive == "Y") {
        this.archive = "N";
        this.getReviewResults();
      } else {
        this.archive = "Y";
        this.getReviewResults();
      }
    },

    selectedEvents(event) {
      this.filter = null;
      this.currentPage = 1; // Reset to first page when event changes
      if (event != undefined) {
        this.selectedEvent = event;
      }
      this.getReviewResults();
    },
    filterStatus(status) {
      this.filter = null;
      this.currentPage = 1; // Reset to first page when status changes
      this.getReviewResults();
    },

    filterObserver(observer) {
      this.filter = null;
      this.currentPage = 1; // Reset to first page when observer changes
      this.getReviewResults();
    },

    setupDropdownPositioning() {
      // Monitor dropdown clicks and adjust positioning
      this.$nextTick(() => {
        const dropdowns = document.querySelectorAll(
          ".actions-dropdown .dropdown-toggle"
        );
        dropdowns.forEach((dropdown) => {
          dropdown.addEventListener("click", (e) => {
            setTimeout(() => {
              this.adjustDropdownPosition(e.target);
            }, 10);
          });
        });
      });
    },

    adjustDropdownPosition(toggleElement) {
      const dropdown = toggleElement.closest(".actions-dropdown");
      if (!dropdown) return;

      const dropdownMenu = dropdown.querySelector(".dropdown-menu");
      if (!dropdownMenu) return;

      // Get viewport width and dropdown position
      const viewportWidth = window.innerWidth;
      const rect = dropdown.getBoundingClientRect();
      const dropdownWidth = 200; // Approximate dropdown width

      // If dropdown would go off-screen on the right, position it to the left
      if (rect.right + dropdownWidth > viewportWidth) {
        dropdownMenu.classList.add("dropdown-menu-right");
        dropdownMenu.style.right = "0";
        dropdownMenu.style.left = "auto";
        dropdownMenu.style.transform = "none";
      } else {
        dropdownMenu.classList.remove("dropdown-menu-right");
        dropdownMenu.style.right = "auto";
        dropdownMenu.style.left = "0";
        dropdownMenu.style.transform = "none";
      }
    },
  },
  watch: {
    rangeDate: {
      handler: function(val, before) {
        if (val != null) {
          if (val.includes("to")) {
            this.filterDateStart = this.rangeDate.split(" to ")[0];
            this.filterDateEnd = this.rangeDate.split(" to ")[1];
            this.currentPage = 1; // Reset to first page when date range changes
            this.getReviewResults();
          }
        }
      },
    },
    filter: {
      handler(newVal) {
        this.filterEvent = null;
        // Reset to first page when the search term changes, then refetch from the
        // backend (debounced to avoid a request on every keystroke).
        this.currentPage = 1;
        this.debouncedSearch();
      },
      immediate: false,
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-wizard.scss";
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
// .table .thead-dark th {
//   background-color: #fcb416 !important;
//   border-color: #fcb416 !important;
// }
/* Table dropdown fix for z-index and overflow */
.table {
  overflow: visible !important;

  td,
  th {
    overflow: visible !important;
    position: relative;
    padding: 0.5rem;
  }

  /* Table wrapper should also allow overflow */
  .table-responsive {
    overflow: visible !important;
  }
}

/* V-Select in table cells - fix z-index issues */
.table .vs__dropdown-toggle {
  position: relative;
  z-index: 10;
}

.table .vs__dropdown-menu {
  position: absolute !important;
  z-index: 1000 !important;
  min-width: 200px;
  max-height: 200px;
  overflow-y: auto;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15) !important;
  border: 1px solid #ddd;
  background: white;
}

/* Fix for Bootstrap table responsive wrapper */
.table-responsive {
  overflow: visible !important;
}

/* Fix for v-select dropdowns in filter row */
.form-group .vs__dropdown-menu {
  z-index: 1050 !important;
}

/* Actions dropdown positioning fix */
.actions-dropdown {
  position: relative !important;

  .dropdown-menu {
    /* Always position dropdown to the left of the button */
    right: 0 !important;
    left: auto !important;
    transform: none !important;
    min-width: 150px;
    max-width: 200px;

    /* Ensure proper z-index */
    z-index: 1050 !important;

    /* Better styling */
    border-radius: 0.375rem;
    box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
    border: 1px solid rgba(0, 0, 0, 0.1);

    /* Force right alignment for all screens */
    &.show {
      right: 0 !important;
      left: auto !important;
      transform: none !important;
    }

    /* Dropdown menu right class override */
    &.dropdown-menu-right {
      right: 0 !important;
      left: auto !important;
      transform: none !important;
    }
  }

  /* Dropdown toggle styling */
  .dropdown-toggle {
    border: none !important;
    background: transparent !important;
    padding: 0.25rem !important;

    &:focus {
      box-shadow: none !important;
    }
  }
}

/* General dropdown positioning improvements */
.table {
  td:last-child {
    position: relative;

    .dropdown-menu {
      right: 0 !important;
      left: auto !important;
      min-width: 150px;
      transform: none !important;
    }
  }
}

.status {
  padding-left: 1rem !important;
}
.animate__animated.animate__heartBeat {
  --animate-duration: 1s;
}
</style>
